import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import MovieGrid from './components/MovieGrid';
import LatestUpdates from './components/LatestUpdates';
import { movies, categories } from '@/mocks/movies';

const hotMovies = movies.filter((m) => m.isHot).slice(0, 10);
const recommendTv = movies.filter((m) => m.category === 'tv').slice(0, 5);
const recommendVariety = movies.filter((m) => m.category === 'variety').slice(0, 5);
const recommendAnime = movies.filter((m) => m.category === 'anime').slice(0, 5);

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '极速影视 - 首页',
    description: '极速影视为您汇集最新上线电影、热播电视剧全集和高清综艺节目单，全部免费在线观看不缓冲，极速影视最新电影大全每日更新追剧不停。',
    url: 'https://www.jisushipin.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '极速影视',
      url: 'https://www.jisushipin.com/',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.jisushipin.com/',
        },
      ],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '极速影视有哪些影视资源？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '极速影视汇集了最新上线电影、热播电视剧全集、高清综艺节目和热门动漫，涵盖科幻、动作、喜剧、古装、仙侠、悬疑等多种类型，每日更新，满足您的追剧需求。',
        },
      },
      {
        '@type': 'Question',
        name: '极速影视的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '极速影视每日更新最新影视资源，电影、电视剧、综艺节目持续上新，确保您不错过任何精彩内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在极速影视找到想看的影片？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页推荐浏览热门影片，或使用分类导航按电影、电视剧、综艺、动漫分类查找。每个分类下还有更细致的子分类，帮助您快速定位喜欢的类型。',
        },
      },
      {
        '@type': 'Question',
        name: '极速影视支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '极速影视支持在电脑、平板和手机等多种设备上浏览，页面采用响应式设计，在不同屏幕尺寸下都能获得良好的浏览体验。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryGrid />
          <LatestUpdates />
          <MovieGrid
            title="热播推荐"
            subtitle="大家都在看的精彩内容"
            movies={hotMovies}
            linkTo="/category/movie"
            linkLabel="更多热播"
          />
          <MovieGrid
            title="精选电视剧"
            subtitle="口碑好剧，追剧首选"
            movies={recommendTv}
            linkTo="/category/tv"
            linkLabel="全部剧集"
          />
          <div className="bg-background-100">
            <MovieGrid
              title="热门综艺"
              subtitle="爆笑不断，欢乐无限"
              movies={recommendVariety}
              linkTo="/category/variety"
              linkLabel="全部综艺"
            />
          </div>
          <MovieGrid
            title="动漫精选"
            subtitle="热血国漫，精彩纷呈"
            movies={recommendAnime}
            linkTo="/category/anime"
            linkLabel="全部动漫"
          />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}